module.exports = __webpack_public_path__ + "static/as_img_left-2c09c0c93a7bc25bae130dff4dd242c1.png";